// src/components/PeoplePlan/EmployeeManagement/hooks/useEmployeeSelection.js
import { useState } from 'react';

export const useEmployeeSelection = () => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const handleCheckboxChange = (employeeId, hasWorkflow) => {
    if (hasWorkflow) {
      return false; // Cannot select employees with active workflows
    }

    setSelectedEmployees((prev) => {
      if (prev.includes(employeeId)) {
        return prev.filter((id) => id !== employeeId);
      } else {
        return [...prev, employeeId];
      }
    });
    return true;
  };

  const clearSelection = () => {
    setSelectedEmployees([]);
  };

  const isSelected = (employeeId) => {
    return selectedEmployees.includes(employeeId);
  };

  return {
    selectedEmployees,
    handleCheckboxChange,
    clearSelection,
    isSelected,
    selectionCount: selectedEmployees.length,
  };
};